import { CognitoUserInterface } from '@investigator/shared/types/auth-types';
import { i18n } from '@investigator/shared/localization';
import { User } from '../generated/graphql';

const { controls, detection } = i18n.pages.detections;

const { assignToMe } = controls;
const { unassigned } = detection;

interface filterAssignableUsersArgs {
  user?: CognitoUserInterface;
  users: User[];
}

export const filterAssignableUsers = ({
  user,
  users,
}: filterAssignableUsersArgs) =>
  users?.length > 0
    ? [
        ...users
          .filter((user) => !!user.alias)
          .filter((user) => user.status === 'active'),
        { alias: unassigned, username: '' },
      ]
        .map((investUser) => {
          return {
            label:
              (user?.username === investUser?.username
                ? assignToMe
                : investUser?.alias) ?? '', // Ensure label is always a string
            value: investUser?.username ?? '', // Ensure value is always a string
          };
        })
        .sort((a, b) => a?.label.localeCompare(b?.label))
    : [];
